import { t as cn } from "./cn-Bfw0euWw.js";
//#region src/load-image.ts
async function loadImage(url) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => resolve();
		img.onerror = reject;
		img.src = url;
	});
}
//#endregion
//#region src/split-highlights.ts
const HIGHLIGHT = /<span style="[^"]*">(.*?)<\/span>/gs;
/**
* Splits a localized message on its `<span style="…">…</span>` highlights
* (one level, no nesting). The style value is copywriter notation such as
* `#2AFD00`, not CSS, so the caller decides how a highlight looks. The
* message is never parsed as HTML: everything outside a highlight stays
* plain text.
*/
function splitHighlights(message) {
	const parts = [];
	let end = 0;
	for (const match of message.matchAll(HIGHLIGHT)) {
		if (match.index > end) parts.push({
			text: message.slice(end, match.index),
			highlighted: false
		});
		parts.push({
			text: match[1] ?? "",
			highlighted: true
		});
		end = match.index + match[0].length;
	}
	if (end < message.length) parts.push({
		text: message.slice(end),
		highlighted: false
	});
	return parts;
}
//#endregion
//#region src/try-catch.ts
async function tryCatch(promise) {
	try {
		return {
			data: await promise,
			error: null
		};
	} catch (error) {
		return {
			data: null,
			error
		};
	}
}
//#endregion
//#region src/wait.ts
function wait(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}
//#endregion
export { cn, loadImage, splitHighlights, tryCatch, wait };

//# sourceMappingURL=index.js.map